import React, { useEffect, useState } from 'react';
import { Button, Tile, TileHeader, TileTitle, TileSubtitle, withNavigation } from 'cantarus-react-ui';
import { FieldDataStrings as Strings, AdminPanelStrings } from '../../utils/config'
import Spinner from '../common/Spinner'
import FieldDataModel from './FieldDataModel';
import * as fieldDataApi from '../../api/fieldDataApi';
import LivePreview from '../LivePreview/LivePreview';

const FieldData = ({ templateId, templateDataModels, handleFieldDataChange }) => {

    const [dataModelsToSave, setDataModelsToSave] = useState(templateDataModels);
    const [dataFields, setDataFields] = useState([]);
    const [loading, setLoading] = useState(true);

    // Fetch Template Data Fields for Template when Template Id Changes
    const fetchDataFields = async () => {
        if (templateId !== 0) {
            var data = await fieldDataApi.getAllDataFieldsByTemplateId(templateId);
            setDataFields(data);
        }
    }

    useEffect(() => {
        fetchDataFields();
        setDataModelsToSave(templateDataModels);
    }, [templateId]);

    useEffect(() => {
        handleFieldDataChange(dataModelsToSave);
    }, [dataModelsToSave]);

    useEffect(() => {
        if (loading) {
            setTimeout(() => setLoading(false), 500);
        }
    }, [loading]);

    const onFieldDataChange = (index, data) => {
        var dataModelArray = dataModelsToSave.slice();
        dataModelArray.splice(index, 1, data);
        setDataModelsToSave(dataModelArray);
    }

    const handleAddFieldModel = (event) => {
        event.preventDefault();
        setDataModelsToSave([...dataModelsToSave, {}]);
    }

    const handleDelete = (index) => {
        var dataModelArray = dataModelsToSave.slice();
        dataModelArray.splice(index, 1);
        setDataModelsToSave(dataModelArray);

        //set loading true to rerender textbox values
        setLoading(true);
    }

    return (
        <div className='field-data-wrapper'>
            <div className='field-data-tiles'>
                <div className='field-data-model-tiles'>
                    {
                        dataModelsToSave.map((dataModel, index) =>
                            <Tile>
                                <TileHeader>
                                    <TileTitle>{Strings.header}</TileTitle>
                                    <TileSubtitle>
                                        {
                                            dataModelsToSave.length > 1 && <Button classes={['icon', 'delete']} title={Strings.deleteModel} onClick={() => handleDelete(index)} />
                                        }
                                    </TileSubtitle>
                                </TileHeader>
                                {
                                    loading ?
                                        <Spinner />
                                        : <FieldDataModel
                                            modelKey={index}
                                            dataFields={dataFields}
                                            initialDataModel={dataModel}
                                            onFieldDataChange={onFieldDataChange} />
                                }
                                <div className='td-field-data-model-index'>{index + 1}</div>
                            </Tile>
                        )
                    }
                </div>
                <div className='field-data-preview-tile'>
                    <LivePreview previewData={dataModelsToSave} templateId={templateId} />
                </div>
            </div>
            <Button classes={['small', 'template-settings-button']} onClick={handleAddFieldModel} text={Strings.add} disabled={templateId === 0} />
        </div>

    );

};

export const FieldDataNav = withNavigation(FieldData, 'fieldData', AdminPanelStrings.fieldDataMenuLabel);
